// extracted by mini-css-extract-plugin
export var measureBox = "_5s-0";